<div class="time-picker-container" [formGroup]="form">
  <div class="time-picker" (wheel)="onScroll($event, 'from')">
    <mat-form-field>
      <app-easy-select
        formControlName="from"
        [options]="hours"
        [hasEmptyOption]="false"
      ></app-easy-select>
    </mat-form-field>
    <div class="step-buttons">
      <button
        type="button"
        [disabled]="form.disabled"
        mat-button
        color="primary"
        (click)="up('from')"
      >
        <mat-icon>keyboard_arrow_up</mat-icon>
      </button>
      <button
        type="button"
        [disabled]="form.disabled"
        mat-button
        color="primary"
        (click)="down('from')"
      >
        <mat-icon>keyboard_arrow_down</mat-icon>
      </button>
    </div>
  </div>
  <div class="time-picker" (wheel)="onScroll($event, 'to')">
    <mat-form-field>
      <app-easy-select
        formControlName="to"
        [options]="hours"
        [hasEmptyOption]="false"
      ></app-easy-select>
    </mat-form-field>
    <div class="step-buttons">
      <button
        type="button"
        [disabled]="form.disabled"
        mat-button
        color="primary"
        (click)="up('to')"
      >
        <mat-icon>keyboard_arrow_up</mat-icon>
      </button>
      <button
        type="button"
        [disabled]="form.disabled"
        mat-button
        color="primary"
        (click)="down('to')"
      >
        <mat-icon>keyboard_arrow_down</mat-icon>
      </button>
    </div>
  </div>
</div>
